import { Card, Stack, Typography } from "@mui/material";
import {
  FILTER_HOVER_CHIP_MARGIN_PX,
  clampFilterHoverChipPosition
} from "../../../components/FacilityManager/Components/Views/SelectFloorPlanView/Functions/clampFilterHoverChipPosition.function";
import type { ColleagueDeskTooltipLine } from "./colleague-workplace-floor.functions";

const TOOLTIP_MAX_WIDTH_PX = 280;
const TOOLTIP_LINE_HEIGHT_PX = 22;
const TOOLTIP_PADDING_PX = 24;

type P = {
  lines: ColleagueDeskTooltipLine[];
  mouseX: number;
  mouseY: number;
};

/** Pointer-following list of names + times for an occupied or partial desk. */
export function ColleagueWorkplaceFloorDeskTooltip({ lines, mouseX, mouseY }: Readonly<P>) {
  if (lines.length === 0) {
    return null;
  }

  const estimatedHeight = TOOLTIP_PADDING_PX + lines.length * TOOLTIP_LINE_HEIGHT_PX;
  const position = clampFilterHoverChipPosition(
    mouseX,
    mouseY,
    globalThis.innerWidth,
    globalThis.innerHeight,
    { width: TOOLTIP_MAX_WIDTH_PX, height: estimatedHeight }
  );

  return (
    <Card
      data-testid="colleague-workplace-floor-desk-tooltip"
      sx={{
        position: "fixed",
        left: position.left,
        top: position.top,
        px: 1.25,
        py: 1,
        maxWidth: `min(${TOOLTIP_MAX_WIDTH_PX}px, calc(100vw - ${FILTER_HOVER_CHIP_MARGIN_PX * 2}px))`,
        boxShadow: 2,
        pointerEvents: "none",
        zIndex: theme => theme.zIndex.tooltip
      }}
    >
      <Stack spacing={0.5}>
        {lines.map(line => (
          <Stack
            key={line.id}
            direction="row"
            spacing={1.5}
            useFlexGap
            justifyContent="space-between"
            data-testid={`colleague-floor-desk-tooltip-line-${line.id}`}
          >
            <Typography
              variant="caption"
              sx={{ fontFamily: "Fira Sans", fontWeight: 600, lineHeight: 1.35 }}
            >
              {line.name}
            </Typography>
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ fontFamily: "Fira Sans", lineHeight: 1.35, whiteSpace: "nowrap" }}
            >
              {line.time}
            </Typography>
          </Stack>
        ))}
      </Stack>
    </Card>
  );
}
